import { useMutation } from "@apollo/client";
import {
    constantsData,
    identifiersData,
    namesData,
    statusTypesData,
} from "data";
import { deleteVideoMutation, getTrackQuery } from "graph";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { openAlert } from "redux/actions";
import { displayErrorHandler } from "utils";

const useDeleteVideo = (trackId) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const [deleteVideoAction, { loading }] = useMutation(
        deleteVideoMutation,
        {
            awaitRefetchQueries: true,
            refetchQueries: [
                {
                    query: getTrackQuery,
                    variables: {
                        where: { id: trackId },
                    },

                },
            ],
        },
    );

    const { deleteVideoPending: deleteVideoPendingToastName } = namesData.toasts;

    const { toast: toastId } = identifiersData.ids;

    const deleteVideo = async (id) => {
        try {
            await deleteVideoAction({
                onCompleted: () => {
                    dispatch(openAlert(
                        t(
                            "messages.deleteMsgs.success",
                            { entity: t("videos.entity") },
                        ),
                        statusTypesData.success,
                    ));
                },
                variables: {
                    where: { id },
                },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        } finally {
            toast.dismiss(`${deleteVideoPendingToastName}_${toastId}`);
        }
    };

    useEffect(
        () => {
            if (loading) {
                toast.info(
                    () => t(
                        "messages.deleteMsgs.pending",
                        { entity: t("videos.entity") },
                    ),
                    { toastId: `${deleteVideoPendingToastName}_${toastId}` },
                );
            }
        },
        [loading], //eslint-disable-line
    );

    return { deleteVideo };
};

export default useDeleteVideo;
